import { checkHttpStatus, parseJSON, expiredToken } from '@utils/response';
import { Token, UserCode } from '@utils/users';
import { errorResponse, okResponse, ok } from '@utils/response';
import { encryption } from '@utils/encryption';

export function getInfoReport(punchId, reportId) {
    const params = {};
    params.userCodeCrypt = encryption(UserCode());
    params.punchIdCrypt = encryption(punchId);
    params.reportIdCrypt = encryption(reportId);
    params.token = Token();

    return fetch('reportEvent/getInfoReport', {
        method: 'post',
        credentials: 'include',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(params)
    })
        .then(checkHttpStatus)
        .then(expiredToken)
        .then(parseJSON)
        .then(response => {
            try {
                const result = response.result;

                if (response.result.codeReturn !== undefined) {
                    return result;
                }

                return okResponse({ result: JSON.parse(result) });
            } catch (e) {
                errorResponse(response);
            }
        })
        .catch(error => {
            return errorResponse(error);
        })
}

export function saveEventReport(model) {
    const params = {};
    params.userCodeCrypt = encryption(UserCode());
    params.reportIdCrypt = encryption(model.reportId);
    params.punchIdCrypt = encryption(model.punchId);
    params.eventNature = model.eventNature;
    params.eventNumber = model.eventNumber;
    params.civicNumber = model.civicNumber;
    params.streetName = model.streetName;
    params.placeName = model.placeName;
    params.office = model.office;
    params.municipality = model.municipality;
    params.postalCode = model.postalCode;
    params.placeType = model.placeType;
    params.occurredDescription = model.occurredDescription,
    params.occurredDateString = model.occurredDateString;
    params.occurredBetweenDescription = model.occurredBetweenDescription,
    params.occurredBetweenDateString = model.occurredBetweenDateString;
    params.occurredAndDescription = model.occurredAndDescription,
    params.occurredAndDateString = model.occurredAndDateString;
    params.reportedDescription = model.reportedDescription,
    params.reportedDateString = model.reportedDateString;
    params.statusA = model.statusA;
    params.companyNameA = model.companyNameA;
    params.firstNameA = model.firstNameA;
    params.birthDateAgeA = model.birthDateAgeA;
    params.occupationA = model.occupationA;
    params.homePhoneA = model.homePhoneA;
    params.workPhoneA = model.workPhoneA;
    params.genderA = model.genderA;
    params.raceA = model.raceA;
    params.heightA = model.heightA;
    params.weightA = model.weightA;
    params.hairA = model.hairA;
    params.eyesA = model.eyesA;
    params.languageA = model.languageA;
    params.othersA = model.othersA;
    params.remarksPartiesInvolvedA = model.remarksPartiesInvolvedA;
    params.statusB = model.statusB;
    params.companyNameB = model.companyNameB;
    params.firstNameB = model.firstNameB;
    params.birthDateAgeB = model.birthDateAgeB;
    params.occupationB = model.occupationB;
    params.homePhoneB = model.homePhoneB;
    params.workPhoneB = model.workPhoneB;
    params.genderB = model.genderB;
    params.raceB = model.raceB;
    params.heightB = model.heightB;
    params.weightB = model.weightB;
    params.hairB = model.hairB;
    params.eyesB = model.eyesB;
    params.languageB = model.languageB;
    params.othersB = model.othersB;
    params.remarksPartiesInvolvedB = model.remarksPartiesInvolvedB;
    params.contactedResourceDescriptionA = model.contactedResourceDescriptionA;
    params.vehicleA = model.vehicleA;
    params.callTimeAString = model.callTimeAString;
    params.arrivalTimeAString = model.arrivalTimeAString;
    params.responderNamesA = model.responderNamesA;
    params.contactedResourceDescriptionB = model.contactedResourceDescriptionB;
    params.vehicleB = model.vehicleB;
    params.callTimeBString = model.callTimeBString;
    params.arrivalTimeBString = model.arrivalTimeBString;
    params.responderNamesB = model.responderNamesB;
    params.remarksResourceContacted = model.remarksResourceContacted;
    params.narration = model.narration;
    params.declaration = model.declaration;
    params.remarks = model.remarks;
    params.writtenBy = model.writtenBy;
    params.accompaniedBy = model.accompaniedBy;
    params.registerNumber = model.registerNumber;
    params.signatureRegisterNumber = model.signatureRegisterNumber;
    params.signatureDateString = model.signatureDateString;
    params.signatureControlDateString = model.signatureControlDateString;
    params.fileCopyGivenTo = model.fileCopyGivenTo;
    params.fileCopyGivenDateString = model.fileCopyGivenDateString;
    params.token = Token();

    return fetch('reportEvent/saveEventReport', {
        method: 'post',
        credentials: 'include',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(params)
    })
        .then(checkHttpStatus)
        .then(expiredToken)
        .then(parseJSON)
        .then(response => {
            try {
                const result = response.result;

                if (response.result.codeReturn !== undefined) {
                    return result;
                }

                return ok();
            } catch (e) {
                errorResponse(response);
            }
        })
        .catch(error => {
            return errorResponse(error);
        })
}

export function getListEventReport(punchId) {
    const params = {};
    params.userCodeCrypt = encryption(UserCode());
    params.punchIdCrypt = encryption(punchId);
    params.token = Token();

    return fetch('reportEvent/getListReport', {
        method: 'post',
        credentials: 'include',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(params)
    })
        .then(checkHttpStatus)
        .then(expiredToken)
        .then(parseJSON)
        .then(response => {
            try {
                const result = response.result;

                if (response.result.codeReturn !== undefined) {
                    return result;
                }

                return okResponse({ result: JSON.parse(result) });
            } catch (e) {
                errorResponse(response);
            }
        })
        .catch(error => {
            return errorResponse(error);
        })
}